import update from 'immutability-helper';
import { REQUEST_AVAILABLE_DRIVERS, SET_AVAILABLE_DRIVERS } from './available-drivers-actions';

const initialState = {
  isFetching: false,
  list: []
};

function availableDriversReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_AVAILABLE_DRIVERS:
      return update(state, {
        isFetching: {$set: true}
      });
    case SET_AVAILABLE_DRIVERS:
      return update(state, {
        isFetching: {$set: false},
        list: {$set: action.payload}
      });
    default:
      return state
  }
}

export default availableDriversReducer;



// WEBPACK FOOTER //
// ./src/components/available-drivers/available-drivers-reducer.js